import { useState, useMemo } from 'react';
import { Container, Navbar, Stack } from 'react-bootstrap';
import { DndContext, DragEndEvent, DragOverlay, pointerWithin } from '@dnd-kit/core';
import { FilterBar } from './components/schedule/FilterBar.js';
import { CalendarHeader } from './components/schedule/CalendarHeader.js';
import { MonthView } from './components/schedule/MonthView';
import { WeekView } from './components/schedule/WeekView.js';
import { DayView } from './components/schedule/DayView.tsx';
import { ListView } from './components/schedule/ListView.tsx';
import { AppointmentCard } from './components/schedule/AppointmentCard.js';
//import { professionals, serviceFunctions } from './data/mockData.ts';
import { useAppointments } from './hooks/useAppointments.ts';
//import { ViewMode, Appointment } from './types/appointment.ts';
import './agenda.css'
import Template from '../../layout/Template.js';
import { usePermissoes } from '../../hooks/usePermissoes.js';
import PermissoesComponent from '../../components/PermissaoComponent.js';
import { tiposAgendamentosUtils } from '../../utils/tiposAgendamentosUtils.js';
import { tiposServicosUtils } from '../../utils/tiposServicosUtils.js';
import { ProfissionaisService } from '../../services/api/Profissionais/ProfissionaisService.js';

const AgendaAgendamentos = ({ }) => {
  const [currentDate, setCurrentDate] = useState(new Date());
  const [viewMode, setViewMode] = useState('month');
  const [selectedProfessional, setSelectedProfessional] = useState('all');
  const [selectedFunction, setSelectedFunction] = useState('all');
  const [selectedStatus, setSelectedStatus] = useState('all');
  const [activeAppointment, setActiveAppointment] = useState(null);
  const [listProfissionais, setListProfissionais] = useState([])
  const [isLoading, setIsloading] = useState(true)
  const [filtros, setFiltros] = useState({ tiposServicosId: 1 })

  const { listPermissoes, isLoadingPerm } = usePermissoes([
    { secoesId: 2, acoesId: 1 },
    { secoesId: 2, acoesId: 2 },
    { secoesId: 2, acoesId: 3 },
    { secoesId: 2, acoesId: 4 }
  ])



  const { appointments, moveAppointment } = useAppointments();


  const serviceFunctions = tiposServicosUtils()





  const filteredAppointments = useMemo(() => {


    console.log(filtros)

    return appointments.filter((apt) => {
      const matchesProfessional =
        selectedProfessional === 'all' || apt.professionalId === selectedProfessional;
      const matchesFunction =
        selectedFunction === 'all' || apt.functionId === selectedFunction;
      const matchesStatus =
        selectedStatus === 'all' || apt.status === selectedStatus;

      return matchesProfessional && matchesFunction && matchesStatus;
    });
  }, [appointments, selectedProfessional, selectedFunction, selectedStatus]);





  ///Filtros
  const fetchProfissionais = async (tiposServicosId) => {

    let filtrosProf = { tiposServicosId: tiposServicosId }
    const data = await ProfissionaisService.getAll(null, filtrosProf);
    // console.log(data)
    if (data.success) {
      setListProfissionais(data.data)
      if (data.data.length > 0) {
        setFiltros({
          tiposServicosId: filtrosProf.tiposServicosId,
          profissionaisId: data.data[0].id
        })
      }

    }

  }


  const handleChangeFiltro = async (e) => {

    const { name, value } = e.target
    if (name == 'filtro_profissionais') {
      setFiltros({
        ...filtros,
        profissionaisId: value,
      })
    }
    if (name == 'filtro_tp_servico') {

      setFiltros({
        ...filtros,
        tiposServicosId: value,
      })

      if (value != 1) {
        // console.log(value)

        await fetchProfissionais(value)
      } else {
        setFiltros({
          ...filtros,
          profissionaisId: '',
          tiposServicosId: value
        })
        setListProfissionais([])
      }
    }
  }



  const handleDragStart = (event) => {
    const { active } = event;
    const appointment = appointments.find((apt) => apt.id === active.id);
    setActiveAppointment(appointment || null);
  };

  const handleDragEnd = (event) => {
    const { active, over } = event;
    setActiveAppointment(null);

    if (over && active.id !== over.id) {
      const appointmentId = active.id;
      const dropData = over.data.current;

      if (dropData?.date) {
        moveAppointment(appointmentId, dropData.date, dropData.time);
      }
    }
  };

  const handleDateClick = (date) => {
    setCurrentDate(date);
    if (viewMode === 'month') {
      setViewMode('day');
    }
  };

  const renderView = () => {
    switch (viewMode) {
      case 'month':
        return (
          <MonthView
            currentDate={currentDate}
            appointments={filteredAppointments}
            onDateClick={handleDateClick}
          />
        );
      case 'week':
        return (
          <WeekView
            currentDate={currentDate}
            appointments={filteredAppointments}
            onDateClick={handleDateClick}
          />
        );
      case 'day':
        return <DayView currentDate={currentDate} appointments={filteredAppointments} />;
      case 'list':
        return <ListView appointments={filteredAppointments} />;
    }
  };

  return (




    <DndContext
      collisionDetection={pointerWithin}
      onDragStart={handleDragStart}
      onDragEnd={handleDragEnd}
    >
      <div className="min-vh-100 bg-light">


        <Container className="py-4">
          <Stack gap={3}>
            <FilterBar
              listProfissionais={listProfissionais}
              functions={serviceFunctions}
              selectedProfessional={selectedProfessional}
              selectedFunction={selectedFunction}
              selectedStatus={selectedStatus}
              viewMode={viewMode}
              handleChangeFiltro={handleChangeFiltro}
              onViewModeChange={setViewMode}
            />

            <CalendarHeader
              currentDate={currentDate}
              viewMode={viewMode}
              onDateChange={setCurrentDate}
            />

            {renderView()}
          </Stack>
        </Container>
      </div>

      <DragOverlay>
        {activeAppointment ? (
          <div style={{ opacity: 0.8, transform: 'rotate(3deg) scale(1.05)' }}>
            <AppointmentCard appointment={activeAppointment} compact={viewMode !== 'list' && viewMode !== 'day'} />
          </div>
        ) : null}
      </DragOverlay>
    </DndContext>


  );
};

export default AgendaAgendamentos;
